enum FileUploadDestination {
    SolutionResources = 0,
    SituationHotSpotImage = 1,
    PublicationCover = 2,
    Publication = 3,
    RichText = 4,
    NotebookImage = 5,
}

export default FileUploadDestination;
